module.exports = __webpack_public_path__ + "static/media/background.249fc910.png";